module.exports = __webpack_public_path__ + "img/skattedag_2.e959d353.png";